import { LocalStorage } from '@ztechapps/common.utils'
import { useMemo } from 'react'

export const useAllLocalStorage = () => {
  return useMemo(() => new LocalStorage(), [])
}
